<template> 
  <router-view/>
</template>

<script>
export default {
  name: 'App',
  mounted(){
  },
  components: {

  }
}
</script>

<style>
#index {
  font-family: poppins;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
</style>
